import module from 'finanzas/module.js'

function FinanzasTablaRelacionalService ($api, $kardex, $q) {
  this.select = function (id_empleado, id_empresa) {
    return $api.post('/kendu/finanzas/tablaRelacional/select', {
      id_empleado: id_empleado,
      id_empresa: id_empresa,
    })
  }

  this.set = function (id_empleado, id_empresa, id_relacional, nombre_largo, data) {
    return $api.post('/kendu/finanzas/tablaRelacional/set', {
      id_empleado: id_empleado,
      id_empresa: id_empresa,
      id_relacional: id_relacional,
      nombre_largo: nombre_largo,
      data: data,
    })
  }

  this.search = function (search, byID, companies) {
    return $api.post('/kendu/finanzas/tablaRelacional/search', {
        search: search.map((row) => [row[0], row[1]]),
        byID: byID,
        companies: companies,
      })
      .then((response) => {
        var requests = {}
        response.forEach(function (uids) {
          uids.forEach(function (uid) {
            requests[uid] = $kardex.$whoIs(uid)
          })
        })
        return $q.all(requests).then(function (kardexes) {
          return search.map(function (row, index) {
            return {
              query: row,
              results: response[index].map(function (uid) {
                return kardexes[uid]
              }),
            }
          })
        })
      })
  }
}

module.service('FinanzasTablaRelacional', FinanzasTablaRelacionalService)



// WEBPACK FOOTER //
// ./src/finanzas/services/FinanzasTablaRelacional.js